import clsx from 'clsx';
import React from 'react';
import styled from 'styled-components';

import '@/administration/pages/ProductEditor/component/courseTeams.scss';
import { JourneyEditViewTeamsMemberRow } from '@/features/journey/admin/atoms/JourneyEditViewTeamsMemberRow';
import { RLearningJourneySessionDiscussionTeam } from '@/store/v2';

const OverTeamSizeStyled = styled.span`
  color: ${({ theme }) => theme.colors.warning.main};
  font-style: italic;
`;

type JourneyEditViewTeamsListProps = {
  teams: RLearningJourneySessionDiscussionTeam[];
  onTeamSwitch: ({ newTeamId, oldTeamId, memberId }: { newTeamId: number; oldTeamId: number; memberId: number }) => void;
};

export const JourneyEditViewTeamsList = ({ teams, onTeamSwitch }: JourneyEditViewTeamsListProps): React.ReactElement => {
  return (
    <div className="grid is-multiline">
      {[...(teams?.values() ?? [])]?.map((team, index) => (
        <div className="grid-cell grid-cell-6" key={index}>
          <nav className="panel">
            <p className={clsx('panel-heading', 'has-text-centered')}>
              {team?.name}
              {team?.members?.length > team?.teamSize && (
                <>
                  <br />
                  <OverTeamSizeStyled>Over team size (max {team.teamSize})</OverTeamSizeStyled>
                </>
              )}
            </p>
            {team?.members?.map((member, memberIndex) => (
              <JourneyEditViewTeamsMemberRow
                member={member}
                teamIndex={index}
                key={memberIndex}
                teams={teams}
                onTeamSwitch={onTeamSwitch}
                teamId={team.id}
              />
            ))}
            {team?.members?.length < team?.teamSize &&
              Array(team?.teamSize - team?.members?.length)
                .fill(0)
                .map((_x, spotIndex) => (
                  <div key={spotIndex} className={clsx('panel-block', 'member-block', 'member-block--free')}>
                    <em>Free spot</em>
                  </div>
                ))}
          </nav>
        </div>
      ))}
    </div>
  );
};
